"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeePaymentMethodEnum = exports.FeeFiltersEnum = exports.FeeAppliedByEnum = exports.FeeAppliedToEnum = exports.FeeTypeEnum = void 0;
var FeeTypeEnum;
(function (FeeTypeEnum) {
    FeeTypeEnum["Flat"] = "Flat";
    FeeTypeEnum["Percent"] = "Percent";
})(FeeTypeEnum = exports.FeeTypeEnum || (exports.FeeTypeEnum = {}));
var FeeAppliedToEnum;
(function (FeeAppliedToEnum) {
    FeeAppliedToEnum["Order"] = "Order";
    FeeAppliedToEnum["Ticket"] = "Ticket";
    FeeAppliedToEnum["Upgrade"] = "Upgrade";
})(FeeAppliedToEnum = exports.FeeAppliedToEnum || (exports.FeeAppliedToEnum = {}));
var FeeAppliedByEnum;
(function (FeeAppliedByEnum) {
    FeeAppliedByEnum["Sellout"] = "Sellout";
    FeeAppliedByEnum["Stripe"] = "Stripe";
    FeeAppliedByEnum["Organization"] = "Organization";
})(FeeAppliedByEnum = exports.FeeAppliedByEnum || (exports.FeeAppliedByEnum = {}));
var FeeFiltersEnum;
(function (FeeFiltersEnum) {
    FeeFiltersEnum["Seated"] = "Seated";
    FeeFiltersEnum["CardEntry"] = "Card Entry";
    FeeFiltersEnum["CardReader"] = "Card Reader Wifi";
    FeeFiltersEnum["CardReaderBluetooth"] = "Card Reader Bluetooth";
    FeeFiltersEnum["GuestTicket"] = "Guest ticket";
})(FeeFiltersEnum = exports.FeeFiltersEnum || (exports.FeeFiltersEnum = {}));
var FeePaymentMethodEnum;
(function (FeePaymentMethodEnum) {
    FeePaymentMethodEnum["CardEntry"] = "Manual Card Entry";
    FeePaymentMethodEnum["CardReader"] = "Card Reader";
    FeePaymentMethodEnum["CardReaderWifi"] = "Card Reader (Wifi)";
    FeePaymentMethodEnum["CardReaderBluetooth"] = "Card Reader (Bluetooth)";
    FeePaymentMethodEnum["Cash"] = "Cash";
    FeePaymentMethodEnum["None"] = "None";
    FeePaymentMethodEnum["Check"] = "Check";
})(FeePaymentMethodEnum = exports.FeePaymentMethodEnum || (exports.FeePaymentMethodEnum = {}));
//# sourceMappingURL=IFee.js.map